export enum Orientation {
    Horizontal = 'horizontal',
    Vertical = 'vertical',
}

export enum MetricCardType {
    Basic = 'Basic',
    Chart = 'Chart',
}